// extracted by mini-css-extract-plugin
export default {"productGrid":"Q3-z","centerLink":"R3-z","productSection":"S3-z","item":"T3-z","ctaButton":"U3-z"};